import Grid from '@mui/material/Grid2';

import {SectionTitleTemplate} from '../HomePageTemplate/components';

import MyAchievementInfoSkeleton from './LoadingStages/MyAchievementInfoSkeleton';
import {
  AchievementItemSkeleton,
  AchievementTabsSkeleton,
  DailyEventsSkeleton,
} from './LoadingStages';

export const AchievementsTemplate = () => (
  <Grid spacing={1.75} container mt={3} mb={3}>
    {/*  */}
    <Grid px={2}>
      <AchievementTabsSkeleton />
    </Grid>
    {/*  */}
    <Grid px={2} mt={1} size={12}>
      <MyAchievementInfoSkeleton />
    </Grid>
    {/*  */}
    <Grid px={2} mt={1} size={12}>
      <SectionTitleTemplate isHowLink={false} />
      <DailyEventsSkeleton />
    </Grid>
    {/*  */}
    <Grid px={2} mt={1} size={12}>
      <SectionTitleTemplate />
      <Grid
        container
        sx={{
          overflow: 'hidden',
          overflowX: 'scroll',
          flexWrap: 'nowrap',
          width: '100%',
          marginTop: '12px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          pr: 2,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        rowSpacing={1}
        columnSpacing={2}>
        {[0, 1, 2, 3].map(item => (
          <AchievementItemSkeleton key={item} />
        ))}
      </Grid>
    </Grid>
    <Grid px={2} mt={1} size={12}>
      <SectionTitleTemplate />
      <Grid
        container
        sx={{
          overflow: 'hidden',
          overflowX: 'scroll',
          flexWrap: 'nowrap',
          width: '100%',
          marginTop: '12px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          pr: 2,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        rowSpacing={1}
        columnSpacing={2}>
        {[0, 1, 2, 3].map(item => (
          <AchievementItemSkeleton key={item} />
        ))}
      </Grid>
    </Grid>
    <Grid px={2} mt={1} size={12}>
      <SectionTitleTemplate />
      <Grid
        container
        sx={{
          overflow: 'hidden',
          overflowX: 'scroll',
          flexWrap: 'nowrap',
          width: '100%',
          marginTop: '12px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          pr: 2,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        rowSpacing={1}
        columnSpacing={2}>
        {[0, 1, 2, 3].map(item => (
          <AchievementItemSkeleton key={item} />
        ))}
      </Grid>
    </Grid>
  </Grid>
);
